import { TabsWithContent } from "@homebound/beam";
import { useState } from "react";
import { NamedFragment } from "src/fragments/commonFragments.generated";
import { BidPackageDetailPage_BidContractRevisionFragment } from "src/routes/bids/BidPackageDetailPage.generated";
import { useBillTermsTab_BasePlanGlobalPlanTasksQuery } from "src/routes/bids/components/BillTermsTab.generated";
import { queryResult } from "src/utils";
import { BillTermsTable } from "./BillTermsTable";

type BillTermsTabProps = { revisions: BillTermsRevision[]; basePlanGlobalTasks: NamedFragment[] };

type BillTermsTabViewProps = Pick<BillTermsTabProps, "revisions"> & { entityId: string; bidPackageId: string };

export function BillTermsTabView({ revisions, entityId, bidPackageId }: BillTermsTabViewProps) {
  const query = useBillTermsTab_BasePlanGlobalPlanTasksQuery({ variables: { entityId, bidPackageId } });
  return queryResult(query, ({ bidPackage }) => {
    const basePlanGlobalPlanTasks = bidPackage.basePlanGlobalPlanTasks.map((gpt) => ({
      id: gpt.id,
      name: gpt.nameForEntity,
    }));
    return <BillTermsTab revisions={revisions} basePlanGlobalTasks={basePlanGlobalPlanTasks} />;
  });
}

export function BillTermsTab({ revisions, basePlanGlobalTasks }: BillTermsTabProps) {
  const [selectedTab, setSelectedTab] = useState<string>(revisions.first?.id ?? "");
  const tabs = revisions.map(({ id, name, revision }) => ({
    name,
    value: id,
    render: () =>
      revision ? (
        <BillTermsTable basePlanGlobalTasks={basePlanGlobalTasks} revision={revision} />
      ) : (
        <div>No costs have been entered yet</div>
      ),
  }));
  return <TabsWithContent tabs={tabs} selected={selectedTab} onChange={setSelectedTab} />;
}

export type BillTermsRevision = {
  id: string;
  name: string;
  revision: BidPackageDetailPage_BidContractRevisionFragment | undefined;
};
